let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jKXeZ")).then(() => parcelRequire('6OxSZ'));